import palomaWebsocket, {} from "@astina/paloma-common-ui/src/services/WebSocket";
import log from "@astina/paloma-common-ui/src/services/Logger";
let wsSub = null;
let updateFn = null;
class CustomerDemandUpdateListener {
    init(onUpdateFn) {
        updateFn = onUpdateFn;
        wsSub = palomaWebsocket.subscribe("/queue/customer-demand-item-update", (message) => {
            const demandItem = JSON.parse(message.body);
            log('Received demand item update', demandItem);
            if (!updateFn) {
                return;
            }
            updateFn(demandItem);
        });
    }
    stop() {
        if (wsSub) {
            wsSub.unsubscribe();
            wsSub = null;
        }
    }
}
export default new CustomerDemandUpdateListener();
